import { JsonSchema, ToastInfo } from "../../../../types";
import { TOAST_MESSAGES } from "../../constants";
import { getExportSchemaTitles } from "../schemaHelpers";

const COA_REQUIRED_FIELDS = [
  "account_number",
  "account_description",
  "account_type",
  "begin_date",
  "control_type_code",
  "control2_type_code",
  "productivity_type_code",
  "statistical_count_type_code",
  "is_posting_description_required",
];

export const validateHeaders = (
  headers: string[],
  schema: JsonSchema,
): ToastInfo | undefined => {
  const schemaTitles = getExportSchemaTitles(schema);
  const requiredHeaders = COA_REQUIRED_FIELDS.map(
    (field) => schemaTitles[field],
  );

  const missingHeaders = requiredHeaders.filter(
    (header) => !headers.includes(header),
  );

  if (missingHeaders.length) {
    return TOAST_MESSAGES.MISSING_IMPORT_COLUMNS(missingHeaders.join(", "));
  }
};
